import { setGlobal, getGlobal } from "reactn";
import Api from "js/core/api";
import { FetchStatus } from "js/react/constants";
import { BaseDataService } from "js/core/models/dataService";
import { ds } from "js/core/models/dataService";
import { dummyAnalytics, dummyAnalyticsData } from "js/react/views/Analytics/dummyAnalytics";
import moment from "moment";

class analyticsDS {
    static initializeStore() {
        setGlobal({
            analytics: {
                status: {
                    type: FetchStatus.UNSET
                }
            }
        });
    }

    static setDummyData() {
        let dummyData = dummyAnalyticsData;
        dummyData.viewsPerDay = [];
        for (let day = 0; day < 10; day++) {
            dummyData.viewsPerDay.push({
                day: moment()
                    .subtract(day, "day")
                    .format("YYYY-MM-DD"),
                views: Math.random() * 20 + 5
            });
        }
        setGlobal({
            analytics: dummyData
        });
    }

    static fetchPresentationAnalytics() {
        let { presentation, presentationId } = getGlobal();
        let timeZone;
        try {
            timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (err) {
            console.error(err);
        }

        setGlobal({
            analytics: {
                status: {
                    type: FetchStatus.LOADING
                }
            }
        });

        setGlobal(
            Promise.all([
                presentation.load().then(() => presentation),
                Api.playerAnalytics.post({
                    presentationId,
                    queryName: "summary"
                }),
                Api.playerAnalytics.post({
                    presentationId,
                    queryName: "viewsPerDay",
                    timeZone
                }),
                Api.playerAnalytics.post({
                    presentationId,
                    queryName: "downloadsPerDay",
                    timeZone
                }),
                Api.playerAnalytics.post({
                    presentationId,
                    queryName: "aggregates"
                }),
                Api.playerAnalytics.post({
                    presentationId,
                    queryName: "viewingAggregates"
                }),
                Api.playerAnalytics.post({
                    presentationId,
                    pageSize: 20,
                    pageOffset: 0,
                    queryName: "recentPlays",
                    timeZone
                }),
                Api.playerAnalytics.post({
                    presentationId,
                    pageSize: 20,
                    pageOffset: 0,
                    queryName: "recentDownloads",
                    timeZone
                }),
            ])
                .then(([
                    presentation,
                    summary,
                    viewsPerDay,
                    downloadsPerDay,
                    aggregates,
                    viewsPerSlide,
                    views,
                    downloads,
                ]) => {
                    return {
                        analytics: {
                            presentation: presentation,
                            viewTimes: summary[0],
                            completion: summary[1],
                            viewsPerDay,
                            downloadsPerDay,
                            aggregates: aggregates[0],
                            viewsPerSlide: viewsPerSlide,
                            views: {
                                data: views,
                                status: {
                                    type: FetchStatus.SUCCESS
                                }
                            },
                            downloads: {
                                data: downloads,
                                status: {
                                    type: FetchStatus.SUCCESS
                                }
                            },
                            status: { type: FetchStatus.SUCCESS }
                        }
                    };
                })
                .catch(err => {
                    return {
                        analytics: {
                            status: {
                                type: FetchStatus.ERROR,
                                message: err.message
                            }
                        }
                    };
                })
        );
    }

    static fetchMoreRecentViews(pageOffset, pageSize) {
        let { presentation, analytics } = getGlobal();

        setGlobal({
            analytics: {
                ...analytics,
                views: {
                    ...analytics.views,
                    status: {
                        type: FetchStatus.LOADING_MORE
                    }
                }
            }
        });

        setGlobal(
            Api.playerAnalytics
                .post({
                    queryName: "recentPlays",
                    presentationId: presentation.id,
                    pageSize,
                    pageOffset,
                })
                .then(result => {
                    const views = {
                        data: analytics.views.data.concat(result),
                        status: {
                            type: FetchStatus.SUCCESS
                        }
                    };
                    return {
                        analytics: {
                            ...analytics,
                            views,
                        }
                    };
                })
                .catch(err => {
                    return {
                        analytics: {
                            ...analytics,
                            views: {
                                status: {
                                    type: FetchStatus.ERROR,
                                    message: err
                                }
                            }
                        }
                    };
                })
        );
    }

    static fetchMoreRecentDownloads(pageOffset, pageSize) {
        let { presentation, analytics } = getGlobal();

        setGlobal({
            analytics: {
                ...analytics,
                downloads: {
                    ...analytics.downloads,
                    status: {
                        type: FetchStatus.LOADING_MORE
                    }
                }
            }
        });

        setGlobal(
            Api.playerAnalytics
                .post({
                    queryName: "recentPlays",
                    presentationId: presentation.id,
                    pageSize,
                    pageOffset,
                })
                .then(result => {
                    const downloads = {
                        data: analytics.downloads.data.concat(result),
                        status: {
                            type: FetchStatus.SUCCESS
                        }
                    };
                    return {
                        analytics: {
                            ...analytics,
                            downloads,
                        }
                    };
                })
                .catch(err => {
                    return {
                        analytics: {
                            ...analytics,
                            downloads: {
                                status: {
                                    type: FetchStatus.ERROR,
                                    message: err
                                }
                            }
                        }
                    };
                })
        );
    }

    static setSelectedLink(linkId, sessionId) {
        let { analytics } = getGlobal();

        setGlobal({
            analytics: {
                ...analytics,
                showSelectedLink: true,
                selectedLink: {
                    status: FetchStatus.LOADING,
                    linkid: linkId,
                    selectedSessionId: sessionId
                }
            }
        });
    }

    static clearSelectedLink() {
        let { analytics } = getGlobal();
        setGlobal({
            analytics: {
                ...analytics,
                showSelectedLink: false
            }
        });
    }

    static fetchLinkAnalytics() {
        let { presentation, analytics } = getGlobal();
        let selectedLink = analytics.selectedLink;

        setGlobal({
            analytics: {
                ...analytics,
                selectedLink: {
                    ...selectedLink,
                    status: { type: FetchStatus.LOADING }
                }
            }
        });

        setGlobal(
            Promise.all([
                Api.playerAnalytics.post({
                    queryName: "linkSummary",
                    presentationId: presentation.id,
                    linkid: selectedLink.linkid
                }),
                Api.playerAnalytics.post({
                    queryName: "recentPlays",
                    linkid: selectedLink.linkid,
                    presentationId: presentation.id,
                    pageSize: 50,
                    pageOffset: 0
                })
            ])
                .then(result => {
                    console.log(result);
                    let summary = result[0][0][0];
                    let completed = result[0][1][0];
                    let viewTimes = result[0][2];
                    let views = result[1];
                    return {
                        analytics: {
                            ...analytics,
                            selectedLink: {
                                ...selectedLink,
                                totalViews: parseInt(summary.totalviews),
                                uniqueViewers: parseInt(summary.uniqueviewers),
                                totalTime: parseInt(summary.totaltime),
                                completed: parseInt(completed.count),
                                viewTimes: viewTimes,
                                // selectedSessionId: views.length ? views[0].groupid : null,
                                views: {
                                    status: { type: FetchStatus.SUCCESS },
                                    data: views
                                },
                                status: { type: FetchStatus.SUCCESS }
                            }
                        }
                    };
                })
                .catch(err => {
                    return {
                        analytics: {
                            ...analytics,
                            selectedLink: {
                                ...selectedLink,
                                status: {
                                    type: FetchStatus.ERROR,
                                    message: err.message
                                }
                            }
                        }
                    };
                })
        );
    }

    static fetchViewsForUser(pageSize, pageOffset) {
        let { presentation, analytics } = getGlobal();
        let selectedLink = analytics.selectedLink;
        let views = (selectedLink.views && selectedLink.views.data) || [];

        setGlobal({
            analytics: {
                ...analytics,
                selectedLink: {
                    ...selectedLink,
                    views: {
                        status: { type: FetchStatus.LOADING },
                        data: views
                    }
                }
            }
        });

        setGlobal(
            Api.playerAnalytics
                .post({
                    linkid: selectedLink.linkid,
                    presentationId: presentation.id,
                    pageSize: pageSize,
                    pageOffset: pageOffset,
                    queryName: "recentPlays"
                })
                .then(result => {
                    return {
                        analytics: {
                            ...analytics,
                            selectedLink: {
                                ...selectedLink,
                                selectedSessionId: result[0].groupid,
                                views: {
                                    status: { type: FetchStatus.SUCCESS },
                                    data: views.concat(result)
                                }
                            }
                        }
                    };
                })
                .catch(err => {
                    return {
                        analytics: {
                            ...analytics,
                            selectedLink: {
                                ...selectedLink,
                                views: {
                                    status: {
                                        type: FetchStatus.ERROR,
                                        message: err.message
                                    }
                                }
                            }
                        }
                    };
                })
        );
    }

    static setActiveSession(sessionId) {
        let { analytics } = getGlobal();
        setGlobal({
            analytics: {
                ...analytics,
                selectedLink: {
                    ...analytics.selectedLink,
                    selectedSessionId: sessionId,
                    sessionDetail: {
                        status: { type: FetchStatus.LOADING },
                        data: null
                    }
                }
            }
        });
    }

    static fetchSessionData(sessionId) {
        let { presentation, analytics } = getGlobal();

        setGlobal({
            analytics: {
                ...analytics,
                selectedLink: {
                    ...analytics.selectedLink,
                    selectedSessionId: sessionId,
                    sessionDetail: {
                        status: { type: FetchStatus.LOADING },
                        data: null
                    }
                }
            }
        });

        setGlobal(
            Api.playerAnalytics
                .post({
                    presentationId: presentation.id,
                    sessionId: sessionId,
                    queryName: "sessionDetail"
                })
                .then(result => {
                    return {
                        analytics: {
                            ...analytics,
                            selectedLink: {
                                ...analytics.selectedLink,
                                selectedSessionId: sessionId,
                                sessionDetail: {
                                    status: { type: FetchStatus.SUCCESS },
                                    data: result
                                }
                            }
                        }
                    };
                })
                .catch(err => {
                    return {
                        analytics: {
                            ...analytics,
                            selectedLink: {
                                ...analytics.selectedLink,
                                selectedSessionId: sessionId,
                                sessionDetail: {
                                    status: {
                                        type: FetchStatus.ERROR,
                                        message: err.message
                                    }
                                }
                            }
                        }
                    };
                })
        );
    }
}

ds.registerDataService(analyticsDS.initializeStore, "presentation");

export default analyticsDS;
